import React, { Component } from 'react'
import { Switch, withRouter, Route } from 'react-router-dom'

import CityPlanCreate from 'Containers/Campaigns/CityPlanCreate'
import Dashboard from 'Containers/Campaigns/Page/Dashboard'
import CityPlans from 'Containers/Campaigns/Page/CityPlans'
import MasterSchedule from 'Containers/Campaigns/Page/MasterSchedule'
import BonusResults from 'Containers/Campaigns/Page/BonusResults'
import ManagePaidAmounts from 'Containers/Campaigns/Page/ManagePaidAmounts'
import LiveMap from 'Containers/Campaigns/Page/LiveMap'

import {
  PrivateRoute,
  AdminRoute,
  CityManagerRoute,
  NotSpyRoute,
} from 'Config/Routing/auth'
import { PATHS } from 'Config/Routing/paths'
import Mission from './../../Containers/Mission'
import CampaignDataHOC from './../../Containers/Campaigns/DataHOC'
import ClientQuestions from '../../Containers/Campaigns/Page/ClientQuestions/container/ClientQuestions'
import CityPlanRouter from './CityPlanRouter'
import { authorization } from 'Module/Auth/Auth'

class CampaignRouterRaw extends Component {
  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.path}${PATHS.campaign.dashboard}`}>
          <PrivateRoute>
            <Dashboard {...this.props} />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.cityPlans}`}
        >
          <PrivateRoute>
            <CityPlans {...this.props} />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.bonusResults}`}
        >
          <PrivateRoute>
            <BonusResults {...this.props} />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.masterSchedule}`}
        >
          <PrivateRoute>
            <MasterSchedule {...this.props} />
          </PrivateRoute>
        </Route>
        <Route exact path={`${this.props.match.path}${PATHS.campaign.liveMap}`}>
          <NotSpyRoute>
            <PrivateRoute
              isRestricted={
                !authorization.isCityManager() && !authorization.isClient()
              }
            >
              <LiveMap {...this.props} />
            </PrivateRoute>
          </NotSpyRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.managePaidAmounts}`}
        >
          <AdminRoute>
            <ManagePaidAmounts {...this.props} />
          </AdminRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.missionView}`}
        >
          <PrivateRoute>
            <Mission {...this.props} />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.rosterMissionView}`}
        >
          <PrivateRoute>
            <Mission {...this.props} />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${
            PATHS.campaign.letterboxMissionsMissionView
          }`}
        >
          <PrivateRoute>
            <Mission {...this.props} />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.missionEdit}`}
        >
          <PrivateRoute>
            <Mission {...this.props} editMode />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.url}${PATHS.campaign.rosterMissionEdit}`}
        >
          <PrivateRoute>
            <Mission {...this.props} editMode />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.url}${
            PATHS.campaign.letterboxMissionsMissionEdit
          }`}
        >
          <PrivateRoute>
            <Mission {...this.props} editMode />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.cityPlanCreate}`}
        >
          <CityManagerRoute>
            <CityPlanCreate {...this.props} />
          </CityManagerRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.clientQuestions}`}
        >
          <PrivateRoute>
            <ClientQuestions {...this.props} />
          </PrivateRoute>
        </Route>
        <Route path={`${this.props.match.path}${PATHS.campaign.cityPlanView}`}>
          <PrivateRoute>
            <CityPlanRouter {...this.props} />
          </PrivateRoute>
        </Route>
      </Switch>
    )
  }
}

export const CampaignRouter = withRouter(props => {
  return (
    <CampaignDataHOC campaignId={props.match.params.campaignId}>
      <CampaignRouterRaw {...props} />
    </CampaignDataHOC>
  )
})



// WEBPACK FOOTER //
// ./src/Config/Routing/CampaignRouter.js